import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { AdvertiserGroupCreationFormComponent } from '../../components/advertiser-group-creation-form/advertiser-group-creation-form.component';
import { Tag } from '~core/models/tag.models';

@Component({
  selector: 'advertiser-group-creation-dialog',
  standalone: true,
  imports: [AdvertiserGroupCreationFormComponent],
  templateUrl: './advertiser-group-creation-dialog.component.html',
  styleUrl: './advertiser-group-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertiserGroupCreationDialogComponent extends BaseComponent {
  advertiser = input<Tag>();
}
